import styled from "styled-components";
import { useMessageStore } from "../../store/MessageStore";

export const Message = () => {
	const messages = useMessageStore((state) => state.messages);
	const removeMessage = useMessageStore((state) => state.removeMessage);

	if (messages.length === 0) {
		return <></>;
	}

	return (
		<StyledComponent>
			{messages.map((msg: any) => {
				return (
					<StyledMessage
						className={`message ${msg.status}`}
						key={msg.id}
						onClick={() => removeMessage(msg.id)}
					>
						{msg.message}
					</StyledMessage>
				);
			})}
		</StyledComponent>
	);
};

const StyledComponent = styled.div`
	position: absolute;
	right: 1rem;
	top: 1rem;
	width: 200px;

	display: flex;
	flex-direction: column;
	gap: 0.2rem;

	& .message {
		background-color: rgb(56, 60, 74);
		border: 1px solid rgba(255, 255, 255, 0.2);

		display: flex;
		align-items: center;
		padding: 1rem;

		text-align: center;

		cursor: pointer;

		animation: fadein 0.5s, fadeout 0.5s 4.5s;
	}

	@keyframes fadein {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
	@keyframes fadeout {
		from {
			opacity: 1;
		}
		to {
			opacity: 0;
		}
	}
`;

const success_color = `#5bc66a`;
const error_color = `#ef5858`;

export const StyledMessage = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-grow: 1;

	color: ${success_color};

	&.error {
		color: ${error_color};
	}
`;
